var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-item",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__product--" + _vm.context
            : "search-result__product",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "product" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-result-item__content" }, [
        _c("h5", {
          staticClass:
            "search-result-item__name typographies-paragraph-medium-bold",
          domProps: { innerHTML: _vm._s(_vm.number) }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "search-result-item__details typographies-paragraph-medium-regular"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.id))]),
            _vm._v(" "),
            _vm.name
              ? _c("span", { domProps: { innerHTML: _vm._s(_vm.name) } })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.description
          ? _c("div", {
              staticClass:
                "search-result-item__description typographies-paragraph-medium-regular",
              domProps: { innerHTML: _vm._s(_vm.description) }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }